import { combineReducers } from "@reduxjs/toolkit";
import addressesReducer from "./addresses";
import authReducer from "./auth-slice";
import cartReducer from "./cart-slice";
import categoriesReducer from "./categories-slice";
import changePasswordReducer from "./change-password-slice";
import colorsReducer from "./colors-slice";
import homeReducer from "./home-slice";
import loginRegisterReducer from "./login-register-slice";
import loginAuthReducer from "./login-auth-slice";
import productReducer from "./product-slice";
import productsListReducer from "./products-list-slice";
import registerFormReducer from "./register-form-slice";
import shippingReducer from "./shipping-slice";
import sizesReducer from "./sizes-slice";
import verifyCodeReducer from "./verfiy-code-slice";
import userReducer from "./user-slice";

const rootReducer = combineReducers({
  addresses: addressesReducer,
  auth: authReducer,
  cart: cartReducer,
  categories: categoriesReducer,
  changePassword: changePasswordReducer,
  colors: colorsReducer,
  home: homeReducer,
  loginRegister: loginRegisterReducer,
  loginAth: loginAuthReducer,
  product: productReducer,
  productsList: productsListReducer,
  registerForm: registerFormReducer,
  shipping: shippingReducer,
  sizes: sizesReducer,
  verifyCode: verifyCodeReducer,
  user: userReducer,
});

export default rootReducer;
